module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2num"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v("4")])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('h2', {
    staticClass: "h2chap"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("LIBBIE")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("• Elizabeth Clift Bacon could walk through a doorway and change a room. Twenty years old in the autumn of 1862, she was a very attractive woman, with a slender figure, brown hair, and blue eyes. She was properly educated for the era, refined, and comfortable amid conversation with both sexes. Vivacious and appealing, she understood the nuances of flirtation, of the shifting currents of attention or affection between a man and a woman. To family, friends, and acquaintances, she was Libbie.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note1",
      "id": "ch04_note1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Libbie Bacon was the daughter of one of Monroe, Michigan’s most respected citizens, Daniel S. Bacon, circuit court judge. Like many of the community’s residents, he had come from elsewhere. In the fall of 1822, at the age of twenty-four, Daniel left his family’s Onondaga County, New York, homestead with a teacher’s certificate and some money, uncertain of his destination. He stopped in Monroe."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note2",
      "id": "ch04_note2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bacon secured a teaching position and purchased ten acres of land, planting a nursery. Ambitious and hardworking, he read law books at night, passed his examination, and opened an office. Eventually, he formed a partnership in a real estate business with Levi S. Humphrey, a transplanted Vermonter whom Bacon had taught to read and write. Humphrey managed a stage line and the Exchange Hotel, and as the town’s first land registrar, he and Bacon bought government land, platted lots, and prospered. Bacon also embraced politics, winning elections as county supervisor, school inspector, and territorial legislator. With statehood, he failed as the Whig candidate for lieutenant governor. By 1837, he served as president of the newly instituted Merchants & Mechanics Bank and as assistant judge of the Monroe County Circuit Court."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note3",
      "id": "ch04_note3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That same year, Bacon married Eleanor Sophia Page, the twenty-three-year-old daughter of a successful Grand Rapids nursery owner. "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("On June 9, 1839, their first child, Edward Augustus, was born. Months later, the bank closed because of a national economic depression, with Bacon, Humphrey, and other investors suffering losses. Bacon, however, was elected to the state senate, and in 1840 was elected an associate judge. Despite personal financial constraints, Bacon built a house on South Monroe Street in the center of town. Here three daughters were born—Libbie on April 8, 1842, and Sophia and Harriet, both of whom died in infancy. Here, too, Edward Augustus, their son, died on April 11, 1848, from a contagious disease after having spent nearly a year in bed with a spinal injury. Six-year-old Libbie, named for her paternal grandmother, was the Bacons’ only surviving child.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note4",
      "id": "ch04_note4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daniel and Sophia doted on Libbie. Both parents punished her for misdeeds but covered her with love and protection. A quiet, devout woman, Sophia taught Libbie a sense of right and wrong that came from within a person. Although strong-willed, Libbie was an obedient child, eager to secure her parents’ approval and that of their friends. When her father gave her a journal on her ninth birthday with the admonition that her handwriting must be neat, she waited another year to begin her entries."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note5",
      "id": "ch04_note5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("5")])]), _vm._v(" When she confided personal thoughts to the journal, she focused on her behavior and the struggles of a young Christian girl. She enjoyed copying poetry, favoring lines that could be guides for future conduct. For her eleventh birthday, she received a piano."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note6",
      "id": "ch04_note6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tragedy revisited the Bacon home, however, in the summer of 1854, when Libbie was twelve years old. On August 12, Sophia Bacon died of “bloody dysentery” after lapsing into a coma. She had never been healthy since her pregnancy with Harriet, and with the loss of a son and daughter within a year, her physical ailments had been compounded by emotional depression. To his family in New York, Daniel wrote: “My poor wife is no more. Her physicians were unacquainted with the nature of her disease. She bore her sufferings with great composure and Christian fortitude . . . . Elizabeth bears her affliction well, but the poor girl does not realize the overdevotion of her mother.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note7",
      "id": "ch04_note7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the father misunderstood the daughter and the depths of her grief. Libbie knew her mothers “overdevotion” and her love for her child. On August 27, Libbie turned to her journal: “Alas! my poor diary you have been sadly neglected. When I last wrote you my Mother sat comfortably in her dear rocking chair by the fire. My dear mother is "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("sleeping her last great sleep from which she never will awake no never! Not even to correct my numerous mistakes.” Continuing: “Two weeks ago my mother was laid in the cold cold ground & as I stood by that open grave & felt Oh! God and know what anguish filled my heart. Oh! why did they put my mother in that great Black coffin & screw the lid down so tight. Oh! what was it for?” Before the funeral, Libbie had removed her mothers wedding ring and cut a locket of hair.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note8",
      "id": "ch04_note8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A short time later, Daniel sent Libbie for a visit to Sophia’s sister, Loraine Richmond, in Grand Rapids, hoping that the company of Loraine’s daughters, Rebecca and Mary, could assuage some of the sorrow. Libbie stayed with the Richmonds until November, when her father brought her back to Monroe. He had vacated their home, renting a room at the Exchange Hotel, and had enrolled Libbie in the Young Ladies’ Seminary and Collegiate Institute, a boarding school founded in 1849. The Reverend Erasmus Boyd served as principal. Libbie had been a student in its primary school."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note9",
      "id": "ch04_note9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Libbie spent the next four years at Boyd’s Seminary, as it was commonly called, or as she subsequently jotted in her journal, “I went there a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("child")]), _vm._v("—but came away a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("woman.")]), _vm._v(" God be praised.” Reverend Boyd and his wife Sarah granted Libbie special privileges at first, allowing her to room with a teacher, Miss Thompson. But Libbie soon learned that as “poor motherless Libbie Bacon” she could extract other favors from sympathetic adults and schoolmates. “How shamelessly I traded on this,” she admitted years later. “What an excuse I made of it for not doing anything I didn’t want to do! And what excuses were made for me on that score.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note10",
      "id": "ch04_note10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bright, serious, and competitive, Libbie excelled as a student. The curriculum emphasized the development of a woman, or as the seminary’s catalog stated, the school sought to “cultivate, not only the mind, but the taste and heart—to make Woman what she should be, not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("masculine")]), _vm._v(", coarse and unlovely, but "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("educated")]), _vm._v(", and at the same time refined, and ready for every good work that becomes her.” The young women studied French, literature, and “Fine Arts.” Social activities were organized by Sarah Boyd. Parents were permitted weekly visits. Upon graduation, the educated young lady should be able to take her place alongside a husband, assisting him in his life’s work and making their home comfortable."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note11",
      "id": "ch04_note11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the attention of the Boyds, the schoolwork and activities at "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("the seminary, and her friends, the pain of her mother’s death healed slowly. Libbie remained lonely and sad: “No one knows how much I lost but myself, when mother died,” she wrote in the winter of 1858. Before the semester ended, her father withdrew her from the school and took her east to stay with his family. Libbie spent the summer with Daniel’s sister, Mary, and her husband, John Case. In the fall, she attended the Young Ladies Institute in Auburn, New York, boarding there for the entire school year before returning to Monroe.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note12",
      "id": "ch04_note12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daniel Bacon, meanwhile, had remarried. He had approached Libbie with the idea in January 1858, in what she described as “a long talk.” “I told him,” she noted in her journal, “if he found a person with whom he could be suited and I would be suited too, and so I will for even if I did feel so averse to his marriage a year ago I have undergone a great change since and I now feel if it would add to my father’s happiness to be married again, I would advise it.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note13",
      "id": "ch04_note13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daniel had met Rhoda Wells Pitts, a widow, through a mutual friend about the time he and Libbie discussed the subject. Her husband, the Reverend Samuel Pitts, had died in 1855 while serving a Presbyterian church in Tecumseh, Michigan. Daniel and Rhoda courted for a year before marrying in Orange, New Jersey, on February 23, 1859—he was sixty years old; she was forty-eight. They boarded with friends until the Bacon house could be repaired and refurbished. Libbie arrived home in June, and by summers end, the family had moved into their home."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note14",
      "id": "ch04_note14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rhoda Bacon possessed qualities that would, in time, endear her to Libbie. Like the deceased Sophia, Rhoda was a devout Christian, laboring in the Presbyterian church. But she had a sense of humor, enjoyed laughter, in contrast to her more sober husband. Libbie later joked to her cousin that “Mother and I laugh and grow fat.” In turn, Rhoda described her stepdaughter as “never so well and fleshy and full of fun and wit.” After visits to the Bacon home and letters from Libbie, Rebecca Richmond asserted that Rhoda “thinks as much of Libbie as Libbie does her.” A friend of the judge told him, as Daniel recalled it, that “my wife governed me, and that Libbie governed both.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note15",
      "id": "ch04_note15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Libbie resumed her studies at Boyd’s Seminary in the fall of 1859. During the semester, however, she became seriously ill and had to withdraw for the year. The nature of her illness is uncertain, but her stepmother ministered to Libbie during the months, undoubtedly contributing to the growing relationship between the two of them."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note16",
      "id": "ch04_note16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Fully recovered by September 1860, Libbie reentered the seminary and would spend the next two years there, until her graduation in June 1862. Once again, she excelled at schoolwork, competing for the coveted rank of class valedictorian. “She mourns past time misapplied,” her stepmother wrote of Libbie in 1861, “and fears she will not get first honors in examinations.” By her graduation, she stood first in the class and delivered the customary farewell address. Rebecca Richmond attended the ceremony and wrote home: “Libbie has a splendid disposition and lovely temperament. I never saw her superior in qualities that go to make up a noble woman. Her parents never restrain her, but encourage her mimicries, drolleries and schoolgirl gaieties.”")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note17",
      "id": "ch04_note17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her years at the seminary, particularly the final two, secured for Libbie lifelong friendships. Libbie and friends Nettie Humphrey and Fanny Fifield drew the attentions of many young men. Seminary women belonged to Monroe’s upper social class and offered prospective beaux acceptance within the city’s most respected families. Libbie’s physical attractiveness and spirited personality lured a variety of attentive men."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note18",
      "id": "ch04_note18",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As it had throughout the nation, the war summoned many eligible young men from Monroe. When they returned on leave, they drew attention in their uniforms from their female friends. Libbie dreamed of marrying a soldier and of accompanying him to the battlefield. Her father did not approve of the visitors in uniform, writing to his sister in 1862: “Libbie like her Aunt Harriet has many suitors, many of the mustached, gilt-striped and Button kind, more interesting to her than to me. My wife and I have a great deal of anxiety about her, but I expect this is true of all parents of fanciful girls.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note19",
      "id": "ch04_note19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At a party given by the Boyds at the seminary on Thanksgiving Day, 1862, Libbie Bacon was introduced to Brevet Captain George Armstrong Custer. Each knew of the other, but the Reeds and Custer did not socialize in the same circles as the Bacons. In fact, Libbie and her father had witnessed Custer’s drunken stumble through the streets the year before. When Conway Noble, a brother of one of Libbie’s best friends, introduced them to each other at the party, the conversation was brief. Libbie remarked, “I believe your promotion has been very rapid?” “I have been very fortunate,” he replied, and that ended the polite meeting."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note20",
      "id": "ch04_note20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That night, as he recounted it, Custer returned to the Reeds’, went to bed, and dreamed of Libbie Bacon. If his subsequent letters to her "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("are to be accepted as sincere—and there is no evidence to suggest otherwise—he fell in love with her that evening at the seminary. His impulsiveness, kindled by his romantic nature, may have contributed to his initial emotions. He may also have viewed her as a challenge, a local belle who had spurned numerous suitors. If either or both were true, he never indicated it. Furthermore, if he had not known already, he would learn shortly that her father did not welcome attention to his daughter from a lowly captain with an unsavory reputation. In his subsequent words, he confronted “well-nigh insurmountable obstacles,” but that did not deter him. They seldom did, as Libbie soon discovered.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note21",
      "id": "ch04_note21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the day following the party, Libbie visited a millinery shop. As she stood at the door, ringing the bell, Custer approached her, stopped, and watched her as she entered the shop. “Oh, how pleased I was,” Libbie admitted later. The captain began attending the Presbyterian church, sitting so he could see her and she him. During the services, “You looked "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("such things")]), _vm._v(" at me,” she jokingly scolded him afterward. Every day, he passed by the Bacon residence, but when he came to the door, she refused to talk with him. A week before Christmas, Custer returned to the army. When her father mentioned his departure—Daniel Bacon was evidently still unaware of the situation—Libbie put her thoughts in her journal, writing: “I could almost have given way to the melting mood. I feel so sorry for him. I think I had something to do with his going.” She confided that she would miss his strolls by the house, but it all had been “in too much haste tho’ I admire his perseverance.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note22",
      "id": "ch04_note22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Custer was back in Monroe by Christmas, however. Why he journeyed to Virginia for such a brief period of time is not in the record. Since McClellan’s removal, he had been trying to secure the colonelcy of the Seventh Michigan Cavalry, a regiment being organized in the state. Initially, he contacted Congressman John Bingham, who recommended that he approach Isaac P. Christiancy, justice of the Michigan Supreme Court and founder of the Republican Party in the state. A Monroe resident, Christiancy agreed to intercede with Governor Austin Blair on Custer’s behalf."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note23",
      "id": "ch04_note23",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blair, however, was unwilling to give the colonelcy, a political patronage appointment, to an officer of Custer’s views and associations. “Custer is using you to his own advantage, just as he used Bingham,” the "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("governor responded to Christiancy. “His people are Rebel Democrats. He himself is a McClellan man; indeed McClellan’s fair-haired boy, I should say. Sorry, your Honor, but I cannot place myself . . . whatever his qualification.”")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note24",
      "id": "ch04_note24",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Custer, meanwhile, was trying to secure a staff appointment for Justice Christiancy’s son Henry, a company captain in a Michigan infantry regiment. Custer agreed to write to members of generals Daniel Butterfields and Andrew Humphreys’s staffs. “I have had experience in company duty and staff duty,” he stated to Christiancy. “The opportunities are infinitely greater in the latter.” Furthermore, Henry would join “with a class of men whom it would be an honor and a pleasure to know.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note25",
      "id": "ch04_note25",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Custer’s efforts succeeded, with Henry Christiancy assigned as aide-de-camp to Humphreys in December. While he was in Virginia, Custer visited Humphreys’s headquarters and perhaps sought a reappointment to the general’s staff. He may also have decided simply to renew friendships, but this seems unlikely, since it required several days of railroad travel between Monroe and Fredericksburg. He may have been seeking assistance or recommendations in his quest for command of the cavalry regiment. Whatever the reasons for the trip, he spent only a few days with the army."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note26",
      "id": "ch04_note26",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once back in Monroe, Custer renewed his daily walks in front of the Bacon home; Libbie thought he passed by “forty times a day.” Libbie expected “a renewal of the attack soon,” but even she had to be surprised at his tenacity. “Whenever I put my nose out of doors,” she informed Rebecca Richmond, Custer was there to meet her. “I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("don’t care for him")]), _vm._v(" except as an escort,” Libbie argued to her close friend Laura Noble. “He just passed the house and I couldn’t forbear making a sketch of him.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note27",
      "id": "ch04_note27",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sometime between Christmas and New Year’s, Custer discussed marriage with Libbie, exclaiming his willingness to “sacrifice every earthly hope to gain my love,” as she entered his words in her journal. “I tell him if I could I would give it to him,” she wrote. “I told him to forget me and he said he "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("never could")]), _vm._v(" forget me and I told him I never should forget "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("him")]), _vm._v(" and I wished to be his true friend through life but it is no use to offer myself as a friend for he will never think of me otherwise than his wife.” But what he had asked was impossible. By now, her father had heard rumors and was adamantly opposed to any relationship "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("between Libbie and Custer. He had forbidden her to invite him into the house and to be seen in his company. “Oh, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Love, love,")]), _vm._v(" how many are made miserable as well as happy by the all powerful influence,” she wondered in her journal.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note28",
      "id": "ch04_note28",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Libbie’s turmoil intensified during the next several weeks. Although Custer continued the pursuit, he began escorting Libbie’s seminary friend and rival, Fanny Fifield, to parties and walking with her in public. With friends, Libbie joked about the army officer and Fanny, but it is evident that his attentions to her troubled Libbie. She was confused about her feelings toward Custer and concerned about her father’s insistent views about him. At a party, she secretly gave him her ring, but days afterward, informed him that he could not see her again—it was what both she and her father wanted."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note29",
      "id": "ch04_note29",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At her father’s urging, Libbie visited family friends in Toledo, Ohio, twenty miles south of Monroe, during February. On the day she left, Custer came to the railroad station, assisting her with baggage and boarding. He had suggested that he accompany her, but she rejected the idea. When Judge Bacon saw him at the station with Libbie, he seethed with anger. Once in Toledo, Libbie wrote home, requesting a dress to wear to a party. Her parents forwarded it, but the judge included a letter, lecturing his daughter about dances and about Custer."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note30",
      "id": "ch04_note30",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Father,” Libbie replied with frustration and anger, “I told Mother to tell you of my interview with Captain Custer. I never had a trial that made me feel so badly. I did it "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("all for you.")]), _vm._v(" I like him very well, and it is pleasant always to have an escort to depend on. But I am sorry I have been with him so much, and you will never see me in the street with him again, and never at the house except to say Good-bye. I told him never to meet me, and he has the sense to understand. But I did not promise "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("never")]), _vm._v(" to see him again. But I will not cause you any more trouble, be sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Continuing, she asked her father not to “blame Captain Custer.” “He has many fine traits,” she added, “and Monroe will yet be proud of him.” Finally: “You have never been a girl, Father, and you cannot tell how hard a trial this was for me. . . . And Monroe people will please mind their own business, and let me alone. If the whole world Oh’d and Ah’d it would not move me as does your displeasure. . . . I wish the gossipers sunk in the sea. It would give me great pleasure to know that you place entire confidence in me—Your affectionate daughter Libbie.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note31",
      "id": "ch04_note31",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("Libbie returned to Monroe by month’s end. Once at home, however, she could no longer resist the deepening affection she had for Custer. While he was seen publicly in the company of Fanny Fifield, Custer and Libbie were able to share moments together at social affairs. He still attended church on Sunday, sitting in a pew near her. Using Nettie Humphrey as a liaison, Libbie passed notes to him and gave him an ambrotype of herself. It was the passion of the man that enticed and reassured. “He acts it, speaks it from his eyes, and tells me every way "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I love you")]), _vm._v(",” she confided in her journal.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note32",
      "id": "ch04_note32",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, Libbie appeared to be trapped in a maze of emotions—her yearnings for him, her pledge to her father. At night, before she slept, Libbie turned to her journal—“A SAFETY VALVE,” she called it—to recount a day’s events, to seek understanding, perhaps comfort. In one entry, she wrote: “I was not in love—yes I was, perhaps, but I am sure that the deep feelings which I know have not been stirred by anyone—the chords of my heart were not swept by him. Yes, I like him so much now—no one knows how much—but I feel that it is proof that I do not really love for how could I silence so soon feelings that are always so deep.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note33",
      "id": "ch04_note33",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On another day, after she had resisted his efforts to kiss her—she believed for the four thousandth time—Libbie confessed, “I long so to put my arms about his neck and kiss him and how often I lay my head on his breast—in imagination—and feel how sweet it would be to make him entirely happy.” Then after they had sat together on a sofa at the Humphrey House, a hotel opened by Nettie’s father in 1860, she avowed, “Darkness reigned. That hand, that tenant hand! He would not let go but held it and kissed "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("oh so passionately")]), _vm._v(":” “I have everything I wish,” she continued, “and have had nearly all my life and now one thing is refused me I sometimes almost rebel. But I shall conquer. In time I’ll learn not to regret or reprove.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note34",
      "id": "ch04_note34",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A week after the incident in the Humphrey House, April 8, Libbie’s twenty-first birthday, Custer boarded a train for Washington, D.C. Orders for a return to duty had been anticipated for some time, and he undoubtedly used the prospects of his departure in his courting of Libbie. The thought that he might fall on a battlefield gave urgency to his desires and requests, but Libbie—if her journal entries can be accepted as accurate—was not swayed, refusing still to allow him to kiss her. Much uncertainty marked their relationship when he left Monroe."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note35",
      "id": "ch04_note35",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("Libbie thought frequently about Custer and evaluated her feelings toward him, as evidenced by her diary entries. Custer, meanwhile, had reported for duty in the capital on April 10. At the War Department, he learned that George B. McClellan had requested his assistance in the preparation of the general’s reports on the campaigns of 1862. He arrived in New York City, where McClellan was posted, the following day, renting a room at the Metropolitan Hotel and visiting with his former commander and the commander’s wife. McClellan and Custer were pleased to see each other again, with McClellan telling his aide that he would have sent for him sooner if he had known where he had been staying.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note36",
      "id": "ch04_note36",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Custer worked with the general in the latter’s residence—a “magnificently furnished” house presented to the McClellans for their use—from ten o’clock in the morning until three o’clock in the afternoon. McClellan sought vindication for his generalship and prepared a lengthy report of the operations. Custer’s assistance, however, was limited, as he soon received orders, reassigning him to the Fifth United States Cavalry, his former regiment. By the end of April, First Lieutenant Custer was at the War Department, temporarily posted to office duty, which he described as “idleness and theatregoing.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch04-note37",
      "id": "ch04_note37",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Monroe, however, never strayed far from his thoughts, nor did Libbie Bacon.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bff392a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 87
// module chunks = 0